module.exports = __webpack_public_path__ + "static/media/walkthrough-circle.defa0b21.svg";